import { useMemo } from 'react';
import { cn } from '../../utils/classNames';
import LeftArrow from '../../assets/icons/BackArrowIcon.svg?react';
import RightArrow from '../../assets/icons/arrow_forward.svg?react';
import { transformPageCountToPageNumberUIArray } from '../../utils/helper';
import XButton from '../common/XButton';

const navListClasses = 'flex items-center gap-2 list-none p-0 m-0';

const pageButtonBaseClasses = `
  text-primary font-normal
  bg-transparent border-0
`;

// Geometry is split off the base so the two states never both set radius or
// padding; when they did, which one won came down to Tailwind's output order.
const pageButtonClasses = `
  px-3! py-1.5! rounded-md!
  hover:bg-primary/10
`;

// A 28px Ocean disc, the size the design gives the current page.
const activePageButtonClasses = `
  w-7! min-w-7! h-7! p-0! rounded-full!
  bg-primary! text-surface!
  hover:bg-primary-hover!
`;

const ellipsisClasses = 'px-3 py-1.5 flex items-center justify-center text-subtle';

const PageButton = ({ active, disabled, onClick, ariaLabel, children }) => (
  <XButton
    variant="ghost"
    onClick={onClick}
    disabled={disabled}
    className={cn(pageButtonBaseClasses, active ? activePageButtonClasses : pageButtonClasses)}
    aria-label={ariaLabel}
    aria-current={active ? 'page' : undefined}
  >
    {children}
  </XButton>
);

const PaginationNavigation = ({ handlePageChange, totalPages, currentPage }) => {
  const pageNumberUIArray = useMemo(
    () => transformPageCountToPageNumberUIArray(totalPages),
    [totalPages]
  );

  if (totalPages <= 1) return null;

  return (
    <nav>
      <ul className={navListClasses}>
        <li>
          <PageButton
            disabled={currentPage === 1}
            onClick={() => handlePageChange(currentPage - 1)}
            ariaLabel="Previous page"
          >
            <LeftArrow />
          </PageButton>
        </li>
        {pageNumberUIArray.map((page, index) => (
          <li key={index}>
            {typeof page === 'number' ? (
              <PageButton
                active={currentPage === page}
                onClick={() => handlePageChange(page)}
                ariaLabel={`Go to page ${page}`}
              >
                {page}
              </PageButton>
            ) : (
              <span className={ellipsisClasses}>{page}</span>
            )}
          </li>
        ))}
        <li>
          <PageButton
            disabled={currentPage === totalPages}
            onClick={() => handlePageChange(currentPage + 1)}
            ariaLabel="Next page"
          >
            <RightArrow />
          </PageButton>
        </li>
      </ul>
    </nav>
  );
};

export default PaginationNavigation;
